import React, { useCallback, useEffect, useState } from 'react';
import { PriceInput } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { WrapToError } from '../../ContributionEmployeesSettings/ContributionEmployeesSettings.styles';
import { ContributionAmountSideKey } from '../../ContributionEmployeesSettings/ContributionEmployeesSettings.types';
import WarnIconWithText from '../../ContributionEmployeesSettings/WarnIconWithText';
import { ChangedContributionRecord, useChangedContributionRecordsStore } from '../useChangedContributionRecords.store';

interface Props {
  amountKey: ContributionAmountSideKey;
  record: ChangedContributionRecord;
}

const AmountInput: React.FC<Props> = ({
  amountKey,
  record,
}) => {
  const { changeRecord } = useChangedContributionRecordsStore();
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => () => setIsFocused(false), []);

  const handleChange = useCallback(
    (val: string) => {
      if (isFocused) {
        changeRecord({ ...record, [amountKey]: val });
      }
    },
    [isFocused, changeRecord, record, amountKey],
  );

  return (
      <WrapToError
        hasError={Boolean(record?.amountsError)}
        width={{ max: '140px', min: '140px' }}
        onBlur={() => setIsFocused(false)}
        onFocus={() => setIsFocused(true)}
      >
        <PriceInput
          testId={`AmountInput_${amountKey}`}
          disabled={record?.isDeleted}
          name={amountKey}
          value={toString(record?.[amountKey])}
          onChange={handleChange}
          placeholder="Set amount"
          allowNegativeValue
          {...(record?.amountsError
            ? {
                rightIcon: <WarnIconWithText
                  message={record?.amountsError}
                />,
              }
            : {})}
        />
      </WrapToError>
  );
};

export default AmountInput;
